/*
  BIZORA COD PRO — ofertas de la ficha: ofertas por cantidad, regalos, comprar junto y producto extra.
  Requiere bz-product.js (window.BZ).
*/
(function () {
  if (!window.BZ) return;

  /* ---------- Ofertas por cantidad ---------- */
  if (!customElements.get('bz-quantity-breaks')) {
    customElements.define(
      'bz-quantity-breaks',
      class extends HTMLElement {
        connectedCallback() {
          this.sid = this.dataset.section;
          this.fmt = this.dataset.money;
          this.unitText = this.dataset.unitText || '';
          this.saveText = this.dataset.saveText || '';
          this.opts = Array.from(this.querySelectorAll('.bz-qb__opt'));
          var base = parseInt(this.dataset.base, 10) || 0;
          var unit = parseInt(this.dataset.unit, 10) || 0;
          var st = BZ.store(this.sid);
          if (!st.variant) st.variant = { price: unit, compare: base > unit ? base : 0, available: true };

          this.addEventListener('change', (e) => {
            var opt = e.target.closest('.bz-qb__opt');
            if (opt) this.choose(opt);
          });

          this.off = BZ.on(this.sid, (state) => this.onState(state));

          var checked = this.querySelector('.bz-qb__radio:checked');
          this.render();
          if (checked) this.choose(checked.closest('.bz-qb__opt'));
        }

        disconnectedCallback() {
          if (this.off) this.off();
        }

        price() {
          var v = BZ.store(this.sid).variant;
          return { price: v ? v.price : 0, base: v ? Math.max(v.compare || 0, v.price) : 0 };
        }

        calc(opt) {
          var q = parseInt(opt.dataset.qty, 10);
          var p = this.price();
          var gross = p.price * q;
          var total = gross;
          var val = parseFloat(opt.dataset.dval) || 0;
          if (opt.dataset.dtype === 'percent') total = Math.round((gross * (100 - val)) / 100);
          else if (opt.dataset.dtype === 'amount') total = gross - Math.round(val * 100);
          if (total < 0) total = 0;
          var strike = p.base * q;
          return { qty: q, total: total, strike: strike, saving: strike - total, unit: Math.round(total / q) };
        }

        render() {
          this.opts.forEach((opt) => {
            var c = this.calc(opt);
            opt.querySelector('[data-bz-total]').textContent = BZ.money(c.total, this.fmt);
            var strike = opt.querySelector('[data-bz-strike]');
            strike.hidden = !(c.strike > c.total);
            strike.textContent = BZ.money(c.strike, this.fmt);
            var save = opt.querySelector('[data-bz-save]');
            save.hidden = !(c.saving > 0 && this.saveText);
            save.textContent = this.saveText.replace('[amount]', BZ.money(c.saving, this.fmt));
            var unit = opt.querySelector('[data-bz-unit]');
            unit.hidden = !(c.qty > 1 && this.unitText);
            unit.textContent = this.unitText.replace('[price]', BZ.money(c.unit, this.fmt));
          });
        }

        choose(opt) {
          this.opts.forEach((o) => {
            var on = o === opt;
            o.classList.toggle('is-selected', on);
            o.querySelector('input').checked = on;
          });
          var c = this.calc(opt);
          this.selected = opt;
          BZ.store(this.sid).pricing = { qty: c.qty, total: c.total, strike: c.strike > c.total ? c.strike : 0 };
          BZ.setQty(this.sid, c.qty);
        }

        onState(state) {
          // precio de la variante nuevo: recalcular tarjetas y el total de la selección
          this.render();
          var match = this.opts.find((o) => parseInt(o.dataset.qty, 10) === state.qty);
          if (!match) {
            // cantidad manual que no coincide con ninguna oferta
            this.opts.forEach((o) => {
              o.classList.remove('is-selected');
              o.querySelector('input').checked = false;
            });
            this.selected = null;
            state.pricing = null;
            return;
          }
          if (match !== this.selected || !state.pricing || state.pricing.qty !== state.qty) {
            this.opts.forEach((o) => {
              o.classList.toggle('is-selected', o === match);
              o.querySelector('input').checked = o === match;
            });
            this.selected = match;
            var c = this.calc(match);
            state.pricing = { qty: c.qty, total: c.total, strike: c.strike > c.total ? c.strike : 0 };
            // avisa a la barra fija y a otros bloques sin volver a escribir la cantidad
            document.dispatchEvent(new CustomEvent('bz:change', { detail: state }));
          }
        }
      }
    );
  }

  /* ---------- Regalos por cantidad ---------- */
  if (!customElements.get('bz-quantity-gifts')) {
    customElements.define(
      'bz-quantity-gifts',
      class extends HTMLElement {
        connectedCallback() {
          this.sid = this.dataset.section;
          this.items = Array.from(this.querySelectorAll('.bz-qg__item'));
          this.msg = this.querySelector('[data-bz-msg]');
          this.off = BZ.on(this.sid, (s) => this.update(s.qty));
          this.update(BZ.store(this.sid).qty);
        }

        disconnectedCallback() {
          if (this.off) this.off();
        }

        update(qty) {
          var next = null;
          this.items.forEach((li) => {
            var min = parseInt(li.dataset.min, 10);
            var open = qty >= min;
            li.classList.toggle('is-unlocked', open);
            li.classList.toggle('is-locked', !open);
            if (!open && (!next || min < parseInt(next.dataset.min, 10))) next = li;
          });
          if (!this.msg) return;
          if (next) {
            var need = parseInt(next.dataset.min, 10) - qty;
            var name = next.querySelector('.bz-qg__name').textContent;
            this.msg.textContent = (this.dataset.nextText || '').replace('[n]', need).replace('[gift]', name);
          } else {
            this.msg.textContent = this.dataset.doneText || '';
          }
        }
      }
    );
  }

  /* ---------- utilidades de variantes de productos extra ---------- */
  function variantOf(root) {
    var el = root.querySelector('[data-bz-variant]');
    if (!el) return null;
    if (el.tagName === 'SELECT') {
      var o = el.options[el.selectedIndex];
      return o ? { id: parseInt(o.value, 10), price: parseInt(o.dataset.price, 10) || 0 } : null;
    }
    return { id: parseInt(el.value, 10), price: parseInt(el.dataset.price, 10) || 0 };
  }

  /* ---------- Comprar junto ---------- */
  if (!customElements.get('bz-bundle')) {
    customElements.define(
      'bz-bundle',
      class extends HTMLElement {
        connectedCallback() {
          this.sid = this.dataset.section;
          this.fmt = this.dataset.money;
          this.discount = parseFloat(this.dataset.discount) || 0;
          this.rows = Array.from(this.querySelectorAll('[data-bz-companion]'));
          this.btn = this.querySelector('[data-bz-add]');
          this.err = this.querySelector('[data-bz-error]');
          var st = BZ.store(this.sid);
          if (!st.variant) st.variant = { price: parseInt(this.dataset.price, 10) || 0, compare: 0, available: true };
          this.addEventListener('change', () => this.refresh());
          this.btn.addEventListener('click', () => this.add());
          this.off = BZ.on(this.sid, () => this.refresh());
          this.refresh();
        }

        disconnectedCallback() {
          if (this.off) this.off();
        }

        active() {
          return this.rows
            .filter((r) => r.querySelector('[data-bz-check]').checked)
            .map((r) => ({ row: r, v: variantOf(r) }))
            .filter((x) => x.v && x.v.id);
        }

        refresh() {
          var st = BZ.store(this.sid);
          var main = st.variant ? st.variant.price * st.qty : 0;
          var mainEl = this.querySelector('[data-bz-main-price]');
          if (mainEl && st.variant) mainEl.textContent = BZ.money(st.variant.price, this.fmt);
          this.rows.forEach((r) => {
            var v = variantOf(r);
            var price = r.querySelector('[data-bz-price]');
            if (v && price) price.textContent = BZ.money(v.price, this.fmt);
          });
          var act = this.active();
          var sum = main + act.reduce((a, x) => a + x.v.price, 0);
          var total = sum;
          var strike = this.querySelector('[data-bz-strike]');
          if (this.discount > 0 && act.length) {
            total = Math.round((sum * (100 - this.discount)) / 100);
            strike.hidden = false;
            strike.textContent = BZ.money(sum, this.fmt);
          } else {
            strike.hidden = true;
          }
          this.querySelector('[data-bz-total]').textContent = BZ.money(total, this.fmt);
          this.btn.disabled = !(st.variant && st.variant.available !== false);
        }

        add() {
          var form = BZ.form(this.dataset.form);
          if (!form) return;
          var items = [BZ.formItem(form)];
          this.active().forEach((x) => items.push({ id: x.v.id, quantity: 1 }));
          if (!items[0].id) return;
          this.btn.disabled = true;
          this.err.hidden = true;
          BZ.addItems(items)
            .catch((e) => {
              this.err.textContent = e.message && e.message !== 'cart' ? e.message : this.dataset.errorText;
              this.err.hidden = false;
            })
            .finally(() => this.refresh());
        }
      }
    );
  }

  /* ---------- Producto extra (casilla) ---------- */
  if (!customElements.get('bz-upsell')) {
    customElements.define(
      'bz-upsell',
      class extends HTMLElement {
        connectedCallback() {
          this.check = this.querySelector('[data-bz-check]');
          this.form = BZ.form(this.dataset.form);
          if (!this.form) return;
          this.handler = (e) => this.onSubmit(e);
          // captura: se ejecuta antes que el envío normal de Dawn
          this.form.addEventListener('submit', this.handler, true);
        }

        disconnectedCallback() {
          if (this.form && this.handler) this.form.removeEventListener('submit', this.handler, true);
        }

        onSubmit(e) {
          if (!this.check.checked) return;
          var v = variantOf(this);
          var item = BZ.formItem(this.form);
          if (!v || !v.id || !item.id) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          var btn = BZ.nativeSubmit(this.form);
          if (btn && btn.getAttribute('aria-disabled') === 'true') return;
          BZ.busy(this.form, true);
          BZ.showError(this.form, '');
          BZ.addItems([item, { id: v.id, quantity: 1 }])
            .catch((err) => BZ.showError(this.form, err.message))
            .finally(() => BZ.busy(this.form, false));
        }
      }
    );
  }
})();
